import React from 'react';
import JavascriptCallbacks from './JavascriptCallbacks.jsx';
import JavascriptAsynchronous from './JavascriptAsynchronous.jsx';
import JavascriptPromises from './JavascriptPromises.jsx';
import JavascriptAsyncAwait from './JavascriptAsyncAwait.jsx';

export default function JsAsync() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold">JS Async</h1>
      <ul className="mt-4 list-disc ml-6">
        <li><a href='/javascript/callbacks' className='underline'>JS Callbacks</a></li>
<li><a href='/javascript/asynchronous' className='underline'>JS Asynchronous</a></li>
<li><a href='/javascript/promises' className='underline'>JS Promises</a></li>
<li><a href='/javascript/async-await' className='underline'>JS Async/Await</a></li>
      </ul>
    </div>
  );
}
